/* eslint-disable no-useless-catch */

/**
 * PeopleMeasurement service
 */

// Utils
import { HTTP_METHOD } from 'utils/constants';
import { IParamGetList } from 'models/UserRequest';

// Configs
import AdminService from 'configs/api/adminService';

const ENDPOINTS = {
  API_GET_PEOPLE_MEASUREMENT: ['/flow-measurement', HTTP_METHOD.GET],
  API_EXPORT_PEOPLE_MEASUREMENT: ['/flow-measurement/export', HTTP_METHOD.GET],
};

class PeopleMeasurementService extends AdminService {
  constructor() {
    super();
  }

  async getPeopleMeasurement(params: IParamGetList) {
    try {
      const results = await this.request(ENDPOINTS.API_GET_PEOPLE_MEASUREMENT, [], null, params);
      return results?.data?.results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }

  async exportPeopleMeasurement(data?: IParamGetList): Promise<any> {
    try {
      const results = await this.request(
        ENDPOINTS.API_EXPORT_PEOPLE_MEASUREMENT,
        [],
        { responseType: 'blob' },
        data
      );
      return results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }
}

export default new PeopleMeasurementService();
